const en_facility_category = {

}

export default en_facility_category;